import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { FONT_SIZE_16_PX, FONT_WEIGHT_NORMAL } from 'popTheme';

const Disclaimer = ({ paragraph1, paragraph2, styleProps }) => {
  const style = useStyle(styleProps);

  return (
    <Box>
      <Typography sx={style.footer}>
        {paragraph1}
        <br />
        {paragraph2}
      </Typography>
    </Box>
  );
};
export default Disclaimer;

const useStyle = (styleProps) => {
  const theme = useTheme();

  const defaultStyles = {
    color: 'text.primary',
    fontWeight: FONT_WEIGHT_NORMAL,
    fontSize: FONT_SIZE_16_PX,
    lineHeight: '150%',
    textAlign: 'center',
    pb: '9.5rem',
    [theme.breakpoints.up('xs')]: {
      pt: '3rem',
      px: '0.75rem',
    },
    [theme.breakpoints.up('sm')]: {
      pt: '0.25rem',
      px: '2.25rem',
    },
    [theme.breakpoints.up('md')]: {
      pt: '2.5rem',
      px: '3.75rem',
      fontSize: '1.25rem',
    },
    [theme.breakpoints.up('lg')]: {
      pt: '3.75rem',
      px: '5.625rem',
    },
  };

  const mergedStyles = { ...defaultStyles, ...styleProps };

  return { footer: mergedStyles };
};
